let AssessmentForUser
import { getAPIURL } from "assessments/utils"
const Assessment = require("assessments/models/assessment").default

/*
A user's state for a specific assessment. Combines the assessment questions
with answers from the user
*/

let _options = {}

export default AssessmentForUser = (function () {
  AssessmentForUser = class AssessmentForUser extends (
    require("lib/static-shim").default(require("lib/utils/model").default)
  ) {
    static initClass() {}

    isNew() {
      return false
    }

    initialize(attributes, options = {}) {
      // TODO: are we intending to use this?

      // _options = options
      _options = Object.assign({}, _options, options)
    }

    url() {
      const url = `${this.id}/for-user/${this.get("userID")}`
      const params = {}

      // TODO: remove stepID attr check after legacy path is gone
      const stepID = this.get("stepID") || this.get("step_id")
      if (stepID) {
        params.sid = stepID
        params.perms = `step_${stepID}`
      }

      return getAPIURL(url, this, params)
    }

    parse(data) {
      return super.parse(this.parseData(data))
    }

    parseData(data) {
      if ((data != null ? data.method : undefined) === "assessment_editor") {
        if (!data) {
          data = this.toJSON()
        }
        data.assessment = this._parseAssessment(data.assessment)
        this._initRandom(data)
        this.assessment = new Assessment(data.assessment, _options)
        if (this.get("stepID")) {
          this.assessment.set("stepID", this.get("stepID"))
        }
        return data
      } else {
        return data
      }
    }

    _initRandom(data) {
      if (_options.isAdmin === true) {
        return
      }
      // TODO: also disable for review/feedback mode (or just set isAdmin?)
      const adata = data.assessment
      if (adata.randomize_question_order || adata.randomize_choice_order) {
        let userID
        return window.App.execute(
          "seed:for:user",
          adata.id,
          (userID = data.user.id)
        )
      }
    }

    _parseAssessment(data) {
      const { questions, answers } = data
      for (var answer of Array.from(answers)) {
        const q = _.find(questions, (q) => q.id === answer.question)
        q.answer = answer
      }
      data.questions = questions
      return data
    }

    reset() {
      return this.fetch().then(() => {
        // Let peeps know about it
        return this.trigger("assessment:reset")
      })
    }
  }
  AssessmentForUser.initClass()
  return AssessmentForUser
})()
